import React from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import type { SideNavigationProps } from "./types";
import { SideNavigationItem } from "./SideNavigationItem";

const modeConfig = {
  expanded: {
    width: 280,
    alignItems: "stretch" as const,
  },
  collapsed: {
    width: 78,
    alignItems: "center" as const,
  },
};

export const SideNavigation: React.FC<SideNavigationProps> = ({
  mode = "expanded",
  items = [],
  activeKey,
  onItemClick,
  linkComponent,
  "aria-label": ariaLabel = "Side navigation",
  testID,
  themeMode,
  themeProductContext = "b2c",
}) => {
  const config = modeConfig[mode];

  return (
    <Box
      as="nav"
      role="navigation"
      aria-label={ariaLabel}
      width={config.width}
      flexDirection="column"
      alignItems={config.alignItems}
      gap={16}
      paddingHorizontal={8}
      testID={testID || "side-navigation"}
    >
      {items.map((item) => (
        <SideNavigationItem
          key={item.key}
          item={item}
          mode={mode}
          isActive={item.key === activeKey}
          onItemClick={onItemClick}
          linkComponent={linkComponent}
          themeMode={themeMode}
          themeProductContext={themeProductContext}
        />
      ))}
    </Box>
  );
};
